import { render, staticRenderFns } from "./Invitation.vue?vue&type=template&id=dc5334b6&scoped=true"
import script from "./Invitation.vue?vue&type=script&lang=js"
export * from "./Invitation.vue?vue&type=script&lang=js"
import style0 from "./Invitation.vue?vue&type=style&index=0&id=dc5334b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5334b6",
  null
  
)

export default component.exports